<div class="chat-area col-md-9 col-8">
    <div class="chat-content {[ if (o.show_send_button) { ]}chat-content-sendbutton{[ } ]}"></div>
    <div class="message-form-container"/>
</div>
